import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Tabs, Tab, Spinner, Alert, Button} from 'react-bootstrap';
import axios from 'axios';

// Importando as abas que já existem e podem ser reutilizadas
import AlergiasTab from './AlergiasTab';
import DocumentosTab from './DocumentosTab';
import HistoricoTab from './HistoricoTab'; // Vamos criar este componente a seguir

const ProntuarioVisualizacaoModal = ({ show, onHide, paciente }) => {
    const [activeTab, setActiveTab] = useState('historico');
    const [historicoConsultas, setHistoricoConsultas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchHistorico = useCallback(async () => {
        if (!paciente?.id) return;

        setIsLoading(true);
        setError(null);
        try {
            // ALTERAÇÃO: Adiciona o parâmetro 'source' para identificar a origem da chamada para a auditoria.
            const response = await axios.get(`/api/pacientes/${paciente.id}/consultas`, {
                params: { source: 'visualizacao' }
            });

            const sortedConsultas = (response.data.paciente.consultas || []).sort((a, b) => b.id - a.id);
            setHistoricoConsultas(sortedConsultas);
        } catch (err) {
            console.error("Erro ao buscar histórico de consultas:", err);
            setError("Não foi possível carregar o histórico do paciente.");
        } finally {
            setIsLoading(false);
        }
    }, [paciente?.id]);

    useEffect(() => {
        if (show) {
            // Ao abrir o modal, busca o histórico e define a aba padrão
            fetchHistorico();
            setActiveTab('historico');
        } else {
            // Limpa os dados ao fechar para não mostrar dados antigos na próxima abertura
            setHistoricoConsultas([]);
        }
    }, [show, fetchHistorico]);

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </Spinner>
                </div>
            );
        }

        if (error) {
            return <Alert variant="danger">{error}</Alert>;
        }

        return (
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="prontuario-visualizacao-tabs" className="mb-3 prontuario-view-tabs">
                <Tab eventKey="historico" title="Histórico de Consultas">
                    <HistoricoTab historico={historicoConsultas} />
                </Tab>
                <Tab eventKey="alergias" title="Alergias">
                    {/* O componente AlergiasTab já busca seus próprios dados */}
                    <AlergiasTab pacienteId={paciente.id} />
                </Tab>
                <Tab eventKey="laudos" title="Laudos">
                    {/* Reutilizamos o DocumentosTab com filtro e em modo de leitura */}
                    <DocumentosTab pacienteId={paciente.id} tipoFiltro="Laudo" readOnly={true} fetchOnMount={true} />
                </Tab>
                <Tab eventKey="documentos" title="Documentos">
                    {/* Reutilizamos o DocumentosTab em modo de leitura para mostrar todos os documentos */}
                    <DocumentosTab pacienteId={paciente.id} readOnly={true} fetchOnMount={true} />
                </Tab>
            </Tabs>
        );
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Prontuário de: {paciente?.nome || 'Carregando...'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: '60vh' }}>
                {paciente ? renderContent() : <p>Nenhum paciente selecionado.</p>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ProntuarioVisualizacaoModal;
